import {objectType} from "_src/constants";
import Wrapper from "_src/wrapper";
import loader from "_src/loader";
import containersCache from "_src/engine/packers/containers_cache";
import reformer from "_src/reformer/reformer";

class SelectableWrapper {
  constructor(propertyGetter) {
    this._selfPropertyGetter = propertyGetter;
  }

  getVisibility() {
    return this._selfPropertyGetter("visible");
  }

  getSelection() {
    return this._selfPropertyGetter("selected");
  }

  getProperty(name) {
    return this._selfPropertyGetter(name);
  }
}

class ContourWrapper extends SelectableWrapper {
  constructor(propertyGetter) {
    super(propertyGetter);
    this.points = null;
  }
}

class SectionWrapper extends SelectableWrapper {
  constructor(propertyGetter) {
    super(propertyGetter);
    this.contours = [];
  }
}

export default class SectionMeasureWrapper extends Wrapper {
  constructor(params) {
    super(params);
    this.type = objectType.SECTION;
    this.sections = [];
  }

  getSelection() {
    return this._selfPropertyGetter("selected");
  }

  setSelection(selected) {
    this._selfPropertySetter("selected", selected);
  }

  getHash() {
    return this._selfPropertyGetter("geometriesSource")["hash"];
  }

  async _loadData() {
    const loadingFiles = new Set();
    const loadingPromises = [];
    for (const sectionData of this._selfPropertyGetter("geometries")) {
      const sectionWrapper = new SectionWrapper(name => sectionData[name]);

      const contoursData = sectionData["contours"];
      for (const contourData of contoursData) {
        const file = contourData["file"];
        const index = contourData["index"];
        const payload = {
          objectID: this.getID(),
          frameID: -1,
          id: index,
        };
        loadingFiles.add(file);

        const contourWrapper = new ContourWrapper(name => contourData[name]);
        const promise = await loader.load(reformer.getProjectDirectory() + file, loader.GEOMETRY, payload).then(geometry => {
          contourWrapper.points = geometry.getItemBuffer("a_position");
        });
        loadingPromises.push(promise);
        sectionWrapper.contours.push(contourWrapper);
      }

      this.sections.push(sectionWrapper);
    }
    await Promise.all(loadingPromises);

    for (const file of loadingFiles) {
      containersCache.releaseContainer(file);
    }
  }

  _unloadData() {
    this.sections.length = 0;
  }
}
